import { Component, type ErrorInfo, type ReactNode } from 'react'
import { BookOpen } from 'lucide-react'

export function GuideUnavailable({ locale }: { locale: string }) {
  return <div role="alert" className="mx-auto max-w-4xl p-8"><BookOpen className="mb-4 size-10 text-muted-foreground"/><h1 className="text-2xl font-semibold">{locale === 'fr' ? 'Ce guide ne peut pas être affiché pour le moment' : 'This guide can\'t be displayed right now'}</h1></div>
}

interface GuideBoundaryProps { locale: string; children?: ReactNode }

/**
 * Last line of defence around the catalogue and the reader: a publication shape
 * the guards did not foresee shows the unavailable state for this block instead
 * of unmounting the host page.
 */
export class GuideBoundary extends Component<GuideBoundaryProps, { failed: boolean }> {
  state = { failed: false }

  static getDerivedStateFromError() {
    return { failed: true }
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('[guides-ui] guide render failed', error, info.componentStack)
  }

  render() {
    return this.state.failed ? <GuideUnavailable locale={this.props.locale}/> : this.props.children
  }
}
